import React from 'react'
import { denormalize, schema } from 'normalizr'
import { connect } from 'react-redux'
import { Button } from '@material-ui/core'

const SaveSurveyButton = ({ state, onSave }) => {
  const handleClick = () => {
    const bucket = new schema.Entity('buckets')
    const answer = new schema.Entity('answers', { bucket })
    const question = new schema.Entity('questions', { answers: [answer] })
    const section = new schema.Entity('sections', { questions: [question] })

    const entities = {
      buckets: state.buckets.byId,
      sections: state.sections.byId,
      questions: state.questions.byId,
      answers: state.answers.byId
    }

    const sectionsIds = state.sections.allIds
    const bucketsIds = state.buckets.allIds
    const mySchema = { buckets: [ bucket ], sections: [ section ] }
    const result = denormalize({ buckets: bucketsIds, sections: sectionsIds }, mySchema, entities)

    onSave(result)
  }

  return <Button variant='contained' color='primary' onClick={handleClick}>Save Config</Button>
}

const mapStateToProps = state => ({
  state
})

export default connect(mapStateToProps)(SaveSurveyButton)
